import type { Player } from './player.type';
import type { traitDefinition } from './trait.type';
import { TraitRegistry, type TraitType } from './trait-registry';

export const createTrait = (owner: Player, type: TraitType) => {
  let classe = TraitRegistry.get(type);
  let def = null;
  if (!classe) {
    const traitDefinition = traits.find((trait) => trait.type == type);
    if (!traitDefinition) {
      throw new Error(`Trait ${type} not found`);
    }
    classe = traitDefinition.class;
    def = traitDefinition;
  }
  const trait = new classe(def);

  trait.owner = owner;
  trait.init();

  return trait;
};

export const traits: Array<traitDefinition> = [];
